module.exports = __webpack_public_path__ + "static/media/bryce_sunset.963945de.jpeg";